var ReactRedux = require('react-redux');
var FilesPresentational = require('../../../components/Admin/Couriers/Files.jsx');

var mapStateToProps = function(state) {
	return state;
};

var mapDispatchToProps = function(dispatch) {
	return {};
};

module.exports = ReactRedux.connect(
	mapStateToProps, mapDispatchToProps
)(FilesPresentational);


// WEBPACK FOOTER //
// ./src/containers/Admin/Couriers/Files.js